import { el, clear } from '../lib/dom.js';
import { metricasDashboard, metricasCracha, lerMetas, salvarMeta, intervaloPeriodo } from '../domain/relatorios.js';
import { velocimetro } from '../ui/gauge.js';
import { abrirModal } from '../ui/modal.js';
import { ehGestor } from '../lib/auth.js';
import { toast } from '../lib/toast.js';

// Filtro GLOBAL por meta (cartões no topo). Inicia em "Fora da meta".
const estado = { periodo: 'u12m', filtro: 'fora' };
const cache = { m: null, cracha: null, metas: null };

const TEMAS = [
  { id: 'chaves', rotulo: 'Chaves', icone: 'ph-key' },
  { id: 'cracha', rotulo: 'Crachá', icone: 'ph-identification-badge' },
];

/** KPIs: painel de velocímetros por tema, com filtro global por meta. */
export const paginaDashboard = {
  async render(container) {
    container.innerHTML = '';
    container.append(
      el('h1', { class: 'view__titulo', text: 'KPIs' }),
      el('p', { class: 'view__sub', text: 'Indicadores-chave com velocímetros. Clique em "Definir meta" em cada um para ajustar o alvo. As faixas verde/amarelo/vermelho indicam o desempenho frente à meta.' }),
    );

    // --- período ---
    const anoAtual = new Date().getFullYear();
    const opcoesPeriodo = [el('option', { value: 'u12m' }, 'Últimos 12 meses')];
    for (let y = anoAtual; y >= anoAtual - 4; y--) opcoesPeriodo.push(el('option', { value: String(y) }, String(y)));
    const hint = el('span', { class: 'dash-periodo-rotulo' });
    const periodoSel = el('select', { class: 'dash-periodo', onChange: (e) => { estado.periodo = e.target.value; pintarHint(); atualizar(); } }, opcoesPeriodo);
    periodoSel.value = estado.periodo;
    function pintarHint() { hint.textContent = estado.periodo === 'u12m' ? '(do mês atual até 12 meses atrás)' : `(ano de ${estado.periodo})`; }
    pintarHint();
    container.append(el('div', { class: 'dash-toolbar' }, [
      el('div', { class: 'dash-toolbar__dir' }, [el('span', { class: 'dash-periodo-rotulo', text: 'Período:' }), periodoSel, hint]),
    ]));

    const corpo = el('div');
    container.append(corpo);

    function abrirMeta(ind) {
      const inp = el('input', { type: 'number', min: '0', max: '100', value: String(ind.meta) });
      abrirModal({
        titulo: `Meta — ${ind.titulo}`,
        corpo: [
          el('p', { class: 'view__sub', style: 'margin-top:0', text: ind.modoBom === 'baixo' ? 'Percentual MÁXIMO aceitável (0 a 100). Abaixo dele = dentro da meta.' : 'Percentual desejado (0 a 100).' }),
          el('div', { class: 'campo' }, [el('label', { text: 'Meta (%)' }), inp]),
        ],
        acoes: [
          { rotulo: 'Cancelar', classe: 'btn' },
          {
            rotulo: 'Salvar', classe: 'btn btn--primario',
            onClick: async () => {
              const v = Math.max(0, Math.min(100, Math.round(Number(inp.value) || 0)));
              const ok = await salvarMeta(ind.cfg, v);
              if (!ok) { toast('Não foi possível salvar (apenas GESTOR).', 'erro'); return false; }
              toast('Meta atualizada.', 'sucesso');
              cache.metas = null; atualizar();
              return true;
            },
          },
        ],
      });
    }

    function indicadores() {
      const m = cache.m, metas = cache.metas, cr = cache.cracha;
      const lista = [
        { id: 'entregues', tema: 'chaves', titulo: 'Entregas e devoluções a pessoas cadastradas', cfg: 'meta_entregues_cadastrados', total: m.entregues_total, bons: m.entregues_cadastrados, meta: metas.entregues_cadastrados, ajuda: 'O que mede: a parcela das MOVIMENTAÇÕES de chave (entregas E devoluções/recebimentos) registradas a/por colaboradores CADASTRADOS, em vez de portadores avulsos.\n\nComo calcula: movimentações SEM marca de avulso (entrega/devolução avulsa) / total de movimentações (entregas + devoluções) no período x 100.\n\nDireção: quanto MAIOR, melhor - rastreabilidade de quem pegou E de quem devolveu cada chave.', unidade: 'movimentações com pessoa cadastrada', modoBom: 'alto' },
        { id: 'devolucoes', tema: 'chaves', titulo: 'Devolvidas no mesmo dia', cfg: 'meta_devolucoes_mesmo_dia', total: m.devolucoes_total, bons: m.devolucoes_mesmo_dia, meta: metas.devolucoes_mesmo_dia, ajuda: 'O que mede: a parcela das chaves devolvidas no MESMO DIA da retirada.\n\nComo calcula: cada devolução é pareada com a retirada anterior da mesma chave e as datas são comparadas no fuso local; devoluções no mesmo dia / total de devoluções no período x 100.\n\nDireção: quanto MAIOR, melhor - a chave não fica retida.', unidade: 'devoluções no mesmo dia', modoBom: 'alto' },
      ];
      if (cr) lista.push({ id: 'cracha_reinc', tema: 'cracha', titulo: 'Reincidência de crachá esquecido (no mês)', cfg: 'meta_cracha_reincidencia', total: cr.reincid_total, bons: cr.reincid_repetentes, meta: metas.cracha_reincidencia, ajuda: 'O que mede: a reincidência de crachá esquecido - colaboradores que esqueceram o crachá MAIS DE UMA VEZ no mesmo mês.\n\nComo calcula: colaboradores reincidentes / colaboradores que esqueceram o crachá no período x 100.\n\nDireção: quanto MENOR, melhor.', unidade: 'reincidentes (colaborador no mês)', modoBom: 'baixo' });
      lista.forEach((i) => {
        i.semDados = !i.total;
        i.pct = i.total ? (i.bons / i.total) * 100 : 0;
        i.dentro = !i.semDados && (i.modoBom === 'baixo' ? i.pct <= i.meta : i.pct >= i.meta);
      });
      return lista;
    }

    function cartaoFiltro(tipo, n, rotulo, icone) {
      const sel = estado.filtro === tipo ? ' sel' : '';
      return el('div', { class: `kpi-filtro kpi-filtro--${tipo}${sel}`, onClick: () => { estado.filtro = tipo; desenhar(); } }, [
        el('div', { class: 'kpi-filtro__n', text: String(n) }),
        el('div', { class: 'kpi-filtro__lab' }, [el('i', { class: `ph ${icone}` }), ' ' + rotulo]),
      ]);
    }

    function abrirAjuda(ind) {
      abrirModal({
        titulo: 'Como é calculado - ' + ind.titulo,
        corpo: [
          el('p', { class: 'view__sub', style: 'margin-top:0; white-space:pre-line; line-height:1.6', text: ind.ajuda }),
          el('p', { class: 'view__sub', style: 'margin-bottom:0', text: 'Meta atual: ' + ind.meta + '%' + (ind.modoBom === 'baixo' ? ' (máximo aceitável).' : ' (mínimo desejado).') }),
        ],
        acoes: [{ rotulo: 'Entendi', classe: 'btn btn--primario' }],
      });
    }

    function gaugeCard(i) {
      const filhos = [
        el('div', { class: 'gauge-card__tit' }, [
          el('span', { text: i.titulo }),
          el('button', { class: 'gauge-card__info', type: 'button', title: 'Como é calculado', 'aria-label': 'Como é calculado', onClick: () => abrirAjuda(i) }, [el('i', { class: 'ph ph-info' })]),
        ]),
        velocimetro({ valor: i.pct, meta: i.meta, modoBom: i.modoBom, semDados: i.semDados }),
        el('div', { class: 'gauge-card__leg', text: i.semDados ? '—' : `${i.bons} de ${i.total} ${i.unidade}` }),
        el('span', { class: `gauge-card__status gauge-card__status--${i.semDados ? 'neutro' : i.dentro ? 'ok' : 'ruim'}`, text: i.semDados ? 'Sem dados no período' : i.dentro ? 'Meta atingida' : 'Fora da meta' }),
        el('div', { class: 'gauge-card__meta', text: `Meta: ${i.meta}%${i.modoBom === 'baixo' ? ' (máx.)' : ''}` }),
      ];
      if (ehGestor()) filhos.push(el('div', { class: 'gauge-card__acao' }, [
        el('button', { class: 'btn', onClick: () => abrirMeta(i) }, [el('i', { class: 'ph ph-target' }), ' Definir meta']),
      ]));
      return el('div', { class: 'gauge-card' }, filhos);
    }

    function desenhar() {
      clear(corpo);
      if (!cache.m) { corpo.append(el('p', { class: 'view__sub', text: 'Não foi possível carregar os indicadores (rode a migração 0014).' })); return; }
      const ind = indicadores();
      const foraN = ind.filter((i) => !i.dentro).length;
      const dentroN = ind.filter((i) => i.dentro).length;

      corpo.append(el('div', { class: 'kpi-rotulo-filtro', text: 'Filtrar indicadores por meta:' }));
      corpo.append(el('div', { class: 'kpi-filtros' }, [
        cartaoFiltro('fora', foraN, 'Fora da meta', 'ph-warning'),
        cartaoFiltro('dentro', dentroN, 'Dentro da meta', 'ph-check-circle'),
        cartaoFiltro('todos', ind.length, 'Todos', 'ph-stack'),
      ]));

      const filtra = (arr) => estado.filtro === 'todos' ? arr : estado.filtro === 'dentro' ? arr.filter((i) => i.dentro) : arr.filter((i) => !i.dentro);

      let algum = false;
      for (const t of TEMAS) {
        const doTema = ind.filter((i) => i.tema === t.id);
        if (!doTema.length) continue;
        const mostra = filtra(doTema);
        const tDentro = doTema.filter((i) => i.dentro).length;
        const tFora = doTema.length - tDentro;
        corpo.append(el('div', { class: 'kpi-tema' }, [
          el('div', { class: 'kpi-tema__tit' }, [el('i', { class: `ph ${t.icone}` }), ' ' + t.rotulo]),
          el('div', { class: 'kpi-tema__badges' }, [
            el('span', { class: 'kpi-badge kpi-badge--na', text: `${tDentro} na meta` }),
            el('span', { class: 'kpi-badge kpi-badge--fora', text: `${tFora} fora` }),
          ]),
        ]));
        if (mostra.length) { corpo.append(el('div', { class: 'gauges' }, mostra.map(gaugeCard))); algum = true; }
      }
      if (!algum) corpo.append(el('p', { class: 'view__sub', text: 'Nenhum indicador neste filtro.' }));
    }

    async function atualizar() {
      const { de, ate } = intervaloPeriodo(estado.periodo);
      const [m, cr, metas] = await Promise.all([
        metricasDashboard(de, ate),
        metricasCracha(de, ate),
        cache.metas ? Promise.resolve(cache.metas) : lerMetas(),
      ]);
      cache.m = m; cache.cracha = cr; cache.metas = metas;
      desenhar();
    }

    await atualizar();
  },
};

/** Badge colorido por tipo de movimentação (reusado na pesquisa). */
export function badgeTipo(tipo) {
  const ok = tipo === 'DEVOLUCAO';
  return el('span', { class: `badge ${ok ? 'badge--ok' : 'badge--alerta'}`, text: tipo === 'RETIRADA' ? 'Retirada' : 'Devolução' });
}